import { AuthParser, UrlBase64JsonParser } from './UrlBase64JsonParser';

const nameof = <T>(name: Extract<keyof T, string>): string => name;

class DefaultAuthFlowParams implements AuthFlowParams {}

export interface AuthFlowParams {
  culture?: string;

  loginFailed?: string;

  guestReturnUrl?: string;
}

export class AuthFlowBuilder {
  private queryParam = 'wauth';

  private cultureFieldName = 'culture';

  private parser: AuthParser;

  constructor(queryParser: AuthParser = new UrlBase64JsonParser()) {
    this.parser = queryParser;
  }

  public withQueryParam(param: string): AuthFlowBuilder {
    this.queryParam = param;

    return this;
  }

  public withCultureFieldName(name: string): AuthFlowBuilder {
    this.cultureFieldName = name;

    return this;
  }

  private setCustomCultureField(json: any, params: AuthFlowParams): void {
    if (this.cultureFieldName !== nameof<AuthFlowParams>('culture')) {
      if (
        json &&
        Object.prototype.hasOwnProperty.call(json, this.cultureFieldName) &&
        typeof json[this.cultureFieldName] === 'string'
      ) {
        params.culture = json[this.cultureFieldName];
      }
    }
  }

  public build(): AuthFlowParams {
    const json = this.parser.parse(this.queryParam);

    let params;
    if (json) {
      params = json as AuthFlowParams;
      this.setCustomCultureField(json, params);
    } else {
      params = new DefaultAuthFlowParams();
    }

    return params;
  }
}
